import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';

import { auth } from './firebase';
import api from '../api/api';
import {
  clearPendingSignupRolePreference,
  getPendingSignupRolePreference,
} from 'domains/auth/utils/registrationRole';

export function register(email, password) {
  return createUserWithEmailAndPassword(auth, email, password);
}

export function login(email, password) {
  return signInWithEmailAndPassword(auth, email, password);
}

export function logOut() {
  return signOut(auth);
}

export function getUserByEmail(email) {
  return auth.getUserByEmail(email);
}

export async function getUserVerificationStatus(firebaseUid) {
  try {
    const response = await api.get(`/users/${firebaseUid}/verification-status`);
    return response.data;
  } catch (error) {
    // AUTO-RECOVERY: If user not in database, create them automatically
    if (error.response?.data?.code === 'USER_NOT_IN_DATABASE') {
      // Prevent race conditions during manual signup
      if (typeof window !== 'undefined' && window.location.pathname.includes('/auth/')) {
        console.log('Skipping auto-recovery in services/auth.js because user is in auth flow.');
        throw error;
      }

      console.log('User not in database - attempting auto-recovery');

      try {
        const currentUser = auth.currentUser;
        if (currentUser) {
          // Get fresh token
          const token = await currentUser.getIdToken();
          const rolePreference =
            getPendingSignupRolePreference(currentUser.email) || 'client';

          // Create MongoDB user with safe default role (idempotent endpoint)
          await api.post('/users', {
            uid: currentUser.uid,
            email: currentUser.email,
            displayName: currentUser.displayName || currentUser.email,
            rolePreference,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });

          clearPendingSignupRolePreference();
          console.log('Auto-recovery successful - user created in database');

          // Retry the original request
          const retryResponse = await api.get(`/users/${firebaseUid}/verification-status`);
          return retryResponse.data;
        }
      } catch (recoveryError) {
        console.error('Auto-recovery failed:', recoveryError);
        throw recoveryError;
      }
    }

    // Re-throw other errors
    throw error;
  }
}
